import { http } from "./Config";

export default {

    login: (login, password) => {
        return http.post('https://teccommerce.com.br/api/isapi.dll/syspedusuario?cnpj_cpf=' + login + "&senha=" + password, 
        {
            
        });
    },
}